module.exports = __webpack_public_path__ + "files/289f204b6b86fb0fe05f64d28972ca5e.png";